import { NgClass, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, INoRowsOverlayParams } from 'ag-grid-community';

type noRowsCustomMessageParams = {
  required: boolean;
  tableName: string;
};
@Component({
  selector: 'no-rows-message',
  imports: [NgIf],
  template: `
    <span *ngIf="!required">This table is optional</span>

    <span *ngIf="required">
      <img
        src="assets/img/trip-2.0/i-bubble.svg"
        alt="Info icon for table requirements"
      />
      At Least one {{ tableName }} required
    </span>
  `,
  styles: `
    span {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      padding-left: 20px;
      padding-top: 125px;
      text-align: left;
    }

    div {    
      position: absolute;
      display: inline;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      padding-left: 45px;
      padding-top: 125px;
      text-align: left;
      p {
        margin: 0;
      }
      
    }
  `,
})
export class NoRowsMessageComponent {
  params: INoRowsOverlayParams & noRowsCustomMessageParams;
  required: boolean = false;
  tableName: string = '';
  agInit(params: INoRowsOverlayParams & noRowsCustomMessageParams): void {
    this.params = params;
    this.required = params.required;
    this.tableName = params.tableName;
    this.refresh(params);
  }
  refresh(params) {
    return true;
  }
}
